import { render, staticRenderFns } from "./fmPrivilege.vue?vue&type=template&id=b25a7ed2&scoped=true&"
import script from "./fmPrivilege.vue?vue&type=script&lang=js&"
export * from "./fmPrivilege.vue?vue&type=script&lang=js&"
import style0 from "./fmPrivilege.vue?vue&type=style&index=0&id=b25a7ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25a7ed2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b25a7ed2')) {
      api.createRecord('b25a7ed2', component.options)
    } else {
      api.reload('b25a7ed2', component.options)
    }
    module.hot.accept("./fmPrivilege.vue?vue&type=template&id=b25a7ed2&scoped=true&", function () {
      api.rerender('b25a7ed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/fmPrivilege.vue"
export default component.exports